export default __webpack_public_path__ + "static/ricohpel-3f71797e20322f9a5a496d6f4a7699d9.png";